<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Visuais das telas das máquinas</h4>
          <router-link to="/app/visual">
            <l-button wide type="primary" round>
              <span class="btn-label">
                <i class="fa fa-plus"></i>
              </span>
              Criar
            </l-button>
          </router-link>
          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <div class="x-page-links">
          <el-input
            v-model="search"
            prefix-icon="el-icon-search"
            style="width: 250px"
            placeholder="Digite para pesquisar"/>
        </div>
        <div class="table-responsive table-full-width">
          <el-table class="table-striped" :data="tableData.filter(data => !search || 
            data.name.toLowerCase().includes(search.toLowerCase()) )">
            <el-table-column label="ID" min-width="80" prop="id" sortable/>
            <el-table-column label="Nome" min-width="250" prop="name" sortable/>
            <el-table-column label="Máquinas" min-width="250" prop="vmName" sortable/>
            <el-table-column label="Ações">
              <div class="td-actions" slot-scope="props">
                <a
                  v-tooltip.top-center="'Edit Profile'"
                  class="btn btn-warning btn-link btn-xs"
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </a>
                <a
                  v-tooltip.top-center="'Delete'"
                  class="btn btn-danger btn-link btn-xs"
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-close"></i>
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      companyList: [],
      search: '',
      machines: []
    };
  },
  computed: {
    tableData() {
      const visuais = this.$store.state.visual.visuais
      
      const populated = visuais.map(v => {
        let vmName = []

      v.vms.filter(e =>{
        for (let index = 0; index < this.machines.length; index++) {
          if (e == this.machines[index].id) {
            vmName.push('-' + this.machines[index].location)
          }
        }
      })
       
        return { ...v, vmName };
      })
      console.log('poppoo', populated)
      return populated
    },
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  mounted() {
    const ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) {
      this.getData(ciaID)
      this.getVm(ciaID)
    } else {
      this.getData()
      this.getVm()
    }
  },
  methods: {
    getData(ciaID) {
      if (ciaID) {
        ciaID = ciaID
      } else {
        ciaID = ''
      }
      this.$store.dispatch("visual/listSort",{sort: '?page_size=300'  + '&company=' + ciaID}).catch(err => console.log(err))
    },
    getVm(ciaID){
      if (ciaID) {
        ciaID = ciaID
      } else {
        ciaID = ''
      }
      this.$store.dispatch("machines/listSort",{sort: '?page_size=300'  + '&company=' + ciaID}).then(data =>{
        this.machines = data
        this.$store.dispatch('lockers/listSort', {sort: '?page_size=300'  + '&company=' + ciaID}).then(resp => {
          for (let index = 0; index < resp.length; index++) {
            this.machines.push(resp[index])
          }
        console.log('machines', this.machines)
        })
      })
    },
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/visual/${row.id}`);
    },
    handleDelete(i, row) {
      console.log(row);
      const itemName = row.name;
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir o visual ${itemName}. Todos os dados serão perdidos!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("visual/delete", { id: row.id }).then(()=>{
          swal.fire({
            title: "Pronto!",
            text: `${itemName} excluída.`,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });

          const ciaID = localStorage.getItem('imachCiaID')
          console.log('cid', ciaID)
          if (ciaID) {
            this.getData(ciaID)
          } else {
            this.getData()
          }

          })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluída.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
</style>
